/**
 * 云源组件「启用线索」公共逻辑
 * 生效条件：type === apiworkid && selectform === 应用获取 && otherConfig.enableClueComponent === true
 */

export function parseApiworkOtherConfig(otherConfig) {
  if (!otherConfig || otherConfig === 'False') return {}
  if (typeof otherConfig === 'object' && !Array.isArray(otherConfig)) return otherConfig
  if (typeof otherConfig === 'string') {
    try {
      let parsed = JSON.parse(otherConfig)
      if (typeof parsed === 'string') {
        try {
          parsed = JSON.parse(parsed)
        } catch (e) { /* keep */ }
      }
      return typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
    } catch (e) {
      return {}
    }
  }
  return {}
}

function isTruthyFlag(val) {
  if (val === true || val === 1) return true
  if (typeof val === 'string') {
    const s = val.trim().toLowerCase()
    return s === 'true' || s === '1'
  }
  return false
}

export function isClueField(item) {
  if (!item || item.type !== 'apiworkid') return false
  if (String(item.selectform || '').trim() !== '应用获取') return false
  const oc = parseApiworkOtherConfig(item.otherConfig)
  return isTruthyFlag(oc.enableClueComponent)
}

export function getClueDisplayText(formData, item) {
  if (!item || !item.model) return ''
  const val = formData[item.model]
  if (val !== undefined && val !== null && String(val).trim() !== '') {
    return String(val).trim()
  }
  const def = item.defaultlable
  if (def !== undefined && def !== null && String(def).trim() !== '') {
    return String(def).trim()
  }
  return ''
}

function getFieldValue(formData, workInfo) {
  if (!workInfo || !workInfo.model) return undefined
  if (workInfo.formtype === 'table' && workInfo.tablekey != null && workInfo.rowindex != null) {
    const rows = formData[workInfo.tablekey]
    return rows && rows[workInfo.rowindex] ? rows[workInfo.rowindex][workInfo.model] : undefined
  }
  return formData[workInfo.model]
}

export function getClueDialogTitle(workInfo, formData, fallbackTitle = '数据提取') {
  if (!workInfo || workInfo.type !== 'apiworkid') return fallbackTitle

  const val = getFieldValue(formData, workInfo)
  if (val !== undefined && val !== null && String(val).trim() !== '') {
    return String(val).trim()
  }

  if (isClueField(workInfo)) {
    const def = workInfo.defaultlable
    if (def !== undefined && def !== null && String(def).trim() !== '') {
      return String(def).trim()
    }
    if (workInfo.label && String(workInfo.label).trim()) {
      return String(workInfo.label).trim()
    }
  }
  return fallbackTitle
}

export function getDetailFieldStyle(item, heightStyle) {
  return isClueField(item) ? 'min-height:auto;height:auto' : heightStyle
}

export function normalizeApiworkFieldConfig(item) {
  if (!item || item.type !== 'apiworkid') return item
  let oc = parseApiworkOtherConfig(item.otherConfig)
  if (!oc || typeof oc !== 'object' || Array.isArray(oc)) {
    oc = {}
  }
  if (oc.enableAdd === undefined) oc.enableAdd = false
  if (oc.enableMultiline === undefined) oc.enableMultiline = false
  if (oc.enableClueComponent === undefined) oc.enableClueComponent = false
  if (oc.viewPermissionPortal === undefined) oc.viewPermissionPortal = ''
  if (!Array.isArray(oc.viewPermissionFallback)) oc.viewPermissionFallback = []
  if (!Array.isArray(oc.viewPermissionFallbackOr)) oc.viewPermissionFallbackOr = []
  item.otherConfig = oc
  if (item.defaultlable === undefined || item.defaultlable === null) {
    item.defaultlable = ''
  }
  return item
}

/** FormatFormLable 中调用：规范化当前字段及表格子列中的云源配置 */
export function normalizeFormItemClueConfig(item) {
  if (item?.type === 'apiworkid') {
    normalizeApiworkFieldConfig(item)
  }
  if (Array.isArray(item?.tableformlist)) {
    item.tableformlist.forEach(sub => {
      if (sub?.type === 'apiworkid') normalizeApiworkFieldConfig(sub)
    })
  }
  return item
}
